import { getCurrentInstance } from 'vue';

export function useRoot() {
  const currentInstance = getCurrentInstance();

  return currentInstance?.proxy.$root;
}
